import {useEffect, useState} from "react";
import { UserContext, updateUserContext } from "../redux/slices/userContextSlice";
import { useAppDispatch } from "../redux/hooks";
import { getApiCall, getUserContextFromAzure } from "../services/apiHelper";
import { GraphAPIURL, TaskmgmtServiceURL } from "../config/config";
import { config } from "process";
import { ServiceName } from "../constants";
const UserContextHook = () => {
    const [userContext, setUserContext] = useState<UserContext>();
    const getProfile = async () => {
        return getUserContextFromAzure(GraphAPIURL).then((user: any) => {
          var currentUserContext = new UserContext();
          currentUserContext.isExternal = user.userType === "Member" ? false : true;
          currentUserContext.email = (
            (!currentUserContext.isExternal
              ? user.userPrincipalName
              : user.mail) as string
          ).toLowerCase();
          currentUserContext.displayName = user.displayName;
          currentUserContext.firstName = user.givenName;
          currentUserContext.lastName = user.surname;
          currentUserContext.usertype = user.userType;
    
          const reqUrl = `${
            TaskmgmtServiceURL + "/userrolemaps/getall"
            }?$filter=(tolower(trim(email)) eq (tolower(trim('${
            currentUserContext.email
            }')))) and (status eq 'Active')`;
          var taskCall = getApiCall(reqUrl, ServiceName.TASKMANAGEMENTSERVICE);
          return taskCall.then(
            (userRoleData: any) => {
              if (userRoleData.result) {
                if (userRoleData.result.length > 0) {
                  currentUserContext = {
                    ...currentUserContext, fundId: userRoleData.result[0].fundId
                  }
                  //currentUserContext.fundId =  userRoleData.result[0].fundId;
                  currentUserContext.FundName = userRoleData.result[0].fundName;
                  currentUserContext.firm = userRoleData.result[0].Firm;
                  currentUserContext.region = userRoleData.result[0].region;
                  currentUserContext.appraiser1 = userRoleData.result.filter(
                    (data: any) => data.role === "Equity Appraiser 1"
                  );
                  currentUserContext.isAppraisal1 =
                    currentUserContext.appraiser1.length > 0 ? true : false;
                  currentUserContext.isEMEA = currentUserContext.region ?.includes(
                    "EMEA"
                  )
                    ? true
                    : false;
                  currentUserContext.isUS = currentUserContext.region ?.includes(
                    "US"
                  )
                    ? true
                    : false;
                  currentUserContext.isAPAC = currentUserContext.region ?.includes(
                    "APAC"
                  )
                    ? true
                    : false;
                  currentUserContext.appraiser2 = userRoleData.result.filter(
                    (data: any) => data.role === "Equity Appraiser 2"
                  );
                  currentUserContext.isAppraisal2 =
                    currentUserContext.appraiser2.length > 0 ? true : false;
                  currentUserContext.appraiser3 = userRoleData.result.filter(
                    (data: any) => data.role === "Equity Appraiser 3"
                  );
                  currentUserContext.isAppraisal3 =
                    currentUserContext.appraiser3.length > 0 ? true : false;
                  currentUserContext.fiduciary = userRoleData.result.filter(
                    (data: any) => data.role === "Equity Fiduciary"
                  );
                  currentUserContext.isFiduciary =
                    currentUserContext.fiduciary.length > 0 ? true : false;
                  currentUserContext.debtAppraiser1 = userRoleData.result.filter(
                    (data: any) => data.role === "Debt Appraiser 1"
                  );
                  currentUserContext.isDebtAppraisal1 =
                    currentUserContext.debtAppraiser1.length > 0 ? true : false;
                  currentUserContext.debtAppraiser2 = userRoleData.result.filter(
                    (data: any) => data.role === "Debt Appraiser 2"
                  );
                  currentUserContext.isDebtAppraisal2 =
                    currentUserContext.debtAppraiser2.length > 0 ? true : false;
                  currentUserContext.debtAppraiser3 = userRoleData.result.filter(
                    (data: any) => data.role === "Debt Appraiser 3"
                  );
                  currentUserContext.isDebtAppraisal3 =
                    currentUserContext.debtAppraiser3.length > 0 ? true : false;
                  currentUserContext.debtFiduciary = userRoleData.result.filter(
                    (data: any) => data.role === "Debt Fiduciary"
                  );
                  currentUserContext.isDebtFiduciary =
                    currentUserContext.debtFiduciary.length > 0 ? true : false;
                  currentUserContext.accounting = userRoleData.result.filter(
                    (data: any) => data.role === "Accounting"
                  );
                  currentUserContext.isAccounting =
                    currentUserContext.accounting.length > 0 ? true : false;
                  currentUserContext.admin = userRoleData.result.filter(
                    (data: any) => data.role === "Admin"
                  );
                  currentUserContext.isAdmin =
                    currentUserContext.admin.length > 0 ? true : false;
                  currentUserContext.audit = userRoleData.result.filter(
                    (data: any) => data.role === "Audit"
                  );
                  currentUserContext.isAudit =
                    currentUserContext.audit.length > 0 ? true : false;
                  currentUserContext.assetManagement = userRoleData.result.filter(
                    (data: any) => data.role === "Asset Management"
                  );
                  currentUserContext.isAssetManagement =
                    currentUserContext.assetManagement.length > 0 ? true : false;
                  currentUserContext.allowedFunds = [];
                  userRoleData?.result.forEach((role: any) => {
                    currentUserContext.allowedFunds.push({
                      fundId: role.fundId,
                      fundName: role.fundName,
                    });
                  });
                }
              }
    
              return currentUserContext;
            },
            (error) => {
              if (error.status == 401) {
                console.log(error);
              }
            }
          );
        });
      
    };
    
 
    useEffect(() => {
      const loadAsync = async () => {
        const appraisalUserContext = localStorage.getItem("AppraisalUserContext");
        if (appraisalUserContext) {
            setUserContext(JSON.parse(appraisalUserContext) as UserContext);
            // dispatch(updateUserContext(JSON.parse(appraisalUserContext)));
          return;
        }
 
        const response:UserContext = await getProfile().then((data:any) => {
            return data;
        })
        setUserContext(response);
        localStorage.setItem("AppraisalUserContext", JSON.stringify(response));
      };
      loadAsync();
    }, []);
 
    return userContext;
  };
 
  export default UserContextHook;